/* American Premium PDP v6 behaviour (approved pdp.js revision 6), bound to the server-rendered Liquid markup.
   Purchases go to the real cart through window.apCart (ap-cart.js) with the selected offer's variant, selling
   plan, quantity and line properties. Motion follows the page's Pause motion control and reduced motion. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduce.matches;
  try { paused ||= localStorage.getItem('ap-home-motion') === 'paused'; } catch (_) {}
  const motionButton = $('[data-motion]');
  function applyMotion() {
    document.body.classList.toggle('paused', paused);
    if (motionButton) {
      motionButton.textContent = paused ? 'Motion paused' : 'Pause motion';
      motionButton.setAttribute('aria-pressed', String(paused));
    }
    if (paused || reduce.matches) document.getAnimations().forEach(a => a.finish());
  }
  applyMotion();
  motionButton?.addEventListener('click', () => { paused = !paused; applyMotion(); try { localStorage.setItem('ap-home-motion', paused ? 'paused' : 'playing'); } catch (_) {} });
  reduce.addEventListener('change', () => { if (reduce.matches) { paused = true; applyMotion(); } });
  const observer = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }), {threshold: .07});
  document.documentElement.classList.add('js');
  $$('.reveal').forEach(el => observer.observe(el));

  function animatePdp(element, frames, duration = 320) {
    if (paused || reduce.matches) return;
    element.getAnimations().forEach(a => a.cancel());
    return element.animate(frames, {duration, easing: 'cubic-bezier(.22,1,.36,1)'});
  }
  const money = cents => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(cents / 100);

  /* Gallery tabs */
  const tabs = $$('[data-gallery]');
  function selectGallery(tab) {
    const position = $('#gallery-position');
    if (position) position.textContent = `${tabs.indexOf(tab) + 1} / ${tabs.length}`;
    tabs.forEach(t => {
      const active = t === tab;
      t.setAttribute('aria-selected', String(active));
      t.tabIndex = active ? 0 : -1;
      const panel = $('#gallery-' + t.dataset.gallery);
      if (!panel) return;
      panel.hidden = !active;
      if (active) animatePdp(panel, [{opacity: 0, transform: 'translateY(6px)'}, {opacity: 1, transform: 'translateY(0)'}], 340);
    });
  }
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => selectGallery(tab));
    tab.addEventListener('keydown', e => {
      let index;
      if (e.key === 'ArrowRight') index = (i + 1) % tabs.length;
      if (e.key === 'ArrowLeft') index = (i + tabs.length - 1) % tabs.length;
      if (e.key === 'Home') index = 0;
      if (e.key === 'End') index = tabs.length - 1;
      if (index !== undefined) { e.preventDefault(); selectGallery(tabs[index]); tabs[index].focus(); }
    });
  });
  $$('[data-zoom]').forEach(b => b.addEventListener('click', () => $('#zoom-dialog')?.showModal()));

  /* Offers */
  const form = $('#purchase');
  // Server-rendered disabled until this script has synced the fields (see ap-product-main); the sticky bar honours it too.
  const purchaseLock = $('[data-purchase-lock]');
  const locked = () => !!purchaseLock && purchaseLock.disabled;
  const offerInputs = $$('input[name="offer"]');
  const mainAdd = $('[data-main-add]');
  const stickyAdd = $('[data-sticky-add]');
  const sticky = $('.pdp-sticky');
  const errorBox = $('[data-purchase-error]');
  const offerOf = input => ({
    id: input.value,
    variant: Number(input.dataset.variant),
    plan: input.dataset.sellingPlan,
    quantity: Number(input.dataset.quantity) || 1,
    total: Number(input.dataset.total),
    totalMoney: input.dataset.totalMoney,
    description: input.dataset.description,
    cadence: input.dataset.cadence,
    renewal: input.dataset.renewal,
    renewalText: input.dataset.renewalText,
    stickyText: input.dataset.stickyText,
    unit: Number(input.dataset.unit),
    unitMoney: input.dataset.unitMoney,
    unitList: Number(input.dataset.unitList),
    unitListMoney: input.dataset.unitListMoney,
    cta: input.dataset.cta || (input.dataset.sellingPlan ? 'START NOW' : 'Add to cart'),
    cartMessage: input.dataset.cartMessage,
    checkoutMessage: input.dataset.checkoutMessage
  });
  let selected = offerInputs.length ? offerOf(offerInputs.find(i => i.checked) || offerInputs[0]) : null;
  const adultButtons = $$('[data-adult-select]');
  const adultSelector = $('.adult-selector');
  let adultOffer = 'monthly';
  let addedOffer = null;
  const soldOut = mainAdd ? mainAdd.disabled : true;
  const bottles = n => `${n} ${n === 1 ? 'bottle' : 'bottles'}`;

  function setField(name, value) {
    const field = form && form.querySelector(`[data-ap-field="${name}"]`);
    if (!field) return;
    field.value = value;
    if (name === 'selling_plan') field.disabled = !value;
  }

  function updatePurchase() {
    if (!selected || !form) return;
    if (adultButtons.length) {
      if (selected.plan) adultOffer = selected.id;
      const selectorSlot = $(`[data-adult-card="${adultOffer}"] [data-adult-selector-slot]`);
      const focusedButton = adultButtons.includes(document.activeElement) ? document.activeElement : null;
      // Keep one set of controls inside the visible card when its native selling plan changes.
      if (selectorSlot && adultSelector.parentElement !== selectorSlot) selectorSlot.appendChild(adultSelector);
      $$('[data-adult-card]').forEach(card => { card.hidden = card.dataset.adultCard !== adultOffer; });
      adultButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.adultSelect === adultOffer)));
      if (focusedButton) focusedButton.focus({preventScroll: true});
    }
    const best = $('[data-best-offer]');
    if (best) {
      best.classList.toggle('is-selected', selected.id === 'three');
      best.setAttribute('aria-pressed', String(selected.id === 'three'));
    }
    offerInputs.forEach(input => {
      const option = input.closest('.offer-option');
      option.classList.toggle('selected', input.checked);
    });
    // The offer shows the price per bottle; this line states the full charge, quantity and renewal cadence.
    const renewalNote = $('#renewal-note');
    // Preserve the complete terms verbatim, with the first charge on its own line on phones.
    const termBreak = selected.renewalText.indexOf('. ');
    if (document.body.classList.contains('ap-reader-pdp') && termBreak > -1) {
      const charge = document.createElement('span');
      charge.className = 'renewal-note__charge';
      charge.textContent = selected.renewalText.slice(0, termBreak + 1);
      const renewal = document.createElement('span');
      renewal.className = 'renewal-note__terms';
      renewal.textContent = selected.renewalText.slice(termBreak + 2);
      renewalNote.replaceChildren(charge, document.createTextNode(' '), renewal);
    } else renewalNote.textContent = selected.renewalText;
    setField('quantity', selected.quantity);
    setField('selling_plan', selected.plan || '');
    setField('type', selected.plan ? 'Subscription' : 'Single');
    // Subscription offers say START NOW, the one-time offer says Add to cart; after a successful add the same offer
    // reads View bag so it is not added twice by accident.
    if (!soldOut) {
      const action = addedOffer === selected.id ? 'View bag' : selected.cta;
      mainAdd.querySelector('span').textContent = action;
      if (stickyAdd) stickyAdd.querySelector('span').textContent = action;
    }
    // The sticky bar shows the price per bottle (server-formatted); the order total stays in the offer and the cart.
    const stickyText = $('#sticky-description'), stickyUnit = $('#sticky-unit'), stickyList = $('#sticky-unit-list');
    if (stickyText) stickyText.textContent = selected.stickyText;
    if (stickyUnit) stickyUnit.textContent = selected.unitMoney;
    if (stickyList) {
      const listAmount = stickyList.querySelector('[data-sticky-list-amount]');
      if (listAmount) listAmount.textContent = selected.unitListMoney;
      else stickyList.textContent = selected.unitListMoney + '/bottle';
      stickyList.setAttribute('aria-label', `Regular price ${selected.unitListMoney} per bottle`);
      stickyList.hidden = !(selected.unitList > selected.unit);
    }
    requestAnimationFrame(updateSticky);
  }
  offerInputs.forEach(input => input.addEventListener('change', () => { selected = offerOf(input); updatePurchase(); }));
  adultButtons.forEach(button => button.addEventListener('click', () => {
    const input = $('#offer-' + button.dataset.adultSelect);
    if (!input || locked()) return;
    input.checked = true;
    selected = offerOf(input);
    updatePurchase();
  }));
  offerInputs.forEach(input => input.addEventListener('keydown', event => {
    if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) return;
    event.preventDefault();
    const choices = offerInputs.filter(offer => !offer.disabled);
    const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
    const next = choices[(choices.indexOf(input) + direction + choices.length) % choices.length];
    if (!next) return;
    next.checked = true;
    selected = offerOf(next);
    updatePurchase();
    const adultButton = adultButtons.find(button => button.dataset.adultSelect === next.value);
    (adultButton || next).focus({preventScroll: true});
  }));
  $('[data-best-offer]')?.addEventListener('click', () => {
    const three = $('#offer-three');
    if (!three || locked()) return;
    three.checked = true;
    selected = offerOf(three);
    updatePurchase();
    three.focus({preventScroll: true});
  });

  function lineItem() {
    const properties = {};
    const typeKey = form.dataset.typeKey;
    if (typeKey) properties[typeKey] = selected.plan ? 'Subscription' : 'Single';
    if (selected.cartMessage && form.dataset.cartMessageKey) properties[form.dataset.cartMessageKey] = selected.cartMessage;
    if (selected.checkoutMessage && form.dataset.checkoutMessageKey) properties[form.dataset.checkoutMessageKey] = selected.checkoutMessage;
    const item = {id: selected.variant, quantity: selected.quantity};
    if (selected.plan) item.selling_plan = Number(selected.plan);
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  let adding = false;
  async function addSelected() {
    if (soldOut || !selected || adding || locked()) return;
    if (addedOffer === selected.id) { window.apCart?.open(); return; }
    if (!window.apCart) { form.submit(); return; }
    // Capture the offer now: the visitor may change the selection while the request runs.
    const submittedOffer = selected.id;
    const item = lineItem();
    const returnFocus = document.activeElement; // before the buttons are disabled
    adding = true;
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    [mainAdd, stickyAdd].forEach(b => { if (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; } });
    try {
      const result = await window.apCart.add([item], errorBox, returnFocus);
      if (result && result.status === 'added') addedOffer = submittedOffer;
    } catch (_) {
      /* the message is shown under the button */
    } finally {
      adding = false;
      [mainAdd, stickyAdd].forEach(b => { if (b) { b.removeAttribute('aria-busy'); b.disabled = false; } });
      updatePurchase();
    }
  }
  form?.addEventListener('submit', e => { e.preventDefault(); addSelected(); });
  // The sticky action buys the selected offer, like the main button; "Change" goes to the options.
  stickyAdd?.addEventListener('click', () => addSelected());
  $('[data-sticky-change]')?.addEventListener('click', e => {
    e.preventDefault();
    form.scrollIntoView({behavior: paused || reduce.matches ? 'instant' : 'smooth', block: 'start'});
    $('input[name="offer"]:checked')?.focus({preventScroll: true});
  });
  document.addEventListener('ap:cart-changed', () => { addedOffer = null; updatePurchase(); });

  /* On reader PDP phones, the sticky action appears only after the complete purchase form has passed. It must not
     obscure the description or compete with plan selection. Desktop retains the title/CTA visibility rule.
     Hidden while any dialog (cart, zoom, film) is open. Its measured height is reserved below the footer.
     Shopify's theme preview bar (#PBarNextFrameWrapper) sits on the viewport bottom: when it is visible, the bar and the
     footer spacer move up by its height and the main button counts as visible only above it (same check as MASI). */
  let scheduled = false;
  let observedToolbar = null;
  const title = $('.product-identity h1');
  const toolbarObserver = 'ResizeObserver' in window ? new ResizeObserver(() => scheduleSticky()) : null;
  function previewBarHeight(viewBottom) {
    const toolbar = document.getElementById('PBarNextFrameWrapper');
    if (toolbar !== observedToolbar && toolbarObserver) {
      if (observedToolbar) toolbarObserver.unobserve(observedToolbar);
      if (toolbar) toolbarObserver.observe(toolbar);
    }
    observedToolbar = toolbar;
    if (!toolbar) return 0;
    const box = toolbar.getBoundingClientRect();
    const style = getComputedStyle(toolbar);
    const visible = box.height > 0 && box.height <= 120 && Math.abs(box.bottom - viewBottom) <= 2 && style.visibility === 'visible' && Number(style.opacity) > 0;
    return visible ? Math.ceil(box.height) : 0;
  }
  function updateSticky() {
    scheduled = false;
    const viewTop = window.visualViewport ? visualViewport.offsetTop : 0;
    const viewBottom = viewTop + (window.visualViewport ? visualViewport.height : innerHeight);
    const toolbarHeight = previewBarHeight(viewBottom);
    document.documentElement.style.setProperty('--ap-preview-bar', toolbarHeight + 'px');
    if (!sticky || !mainAdd || !selected || locked()) return;
    const cta = mainAdd.getBoundingClientRect();
    const pastTitle = title ? title.getBoundingClientRect().bottom < viewTop : true;
    const mainVisible = cta.top >= viewTop && cta.bottom <= viewBottom - toolbarHeight;
    const modal = !!document.querySelector('dialog[open]');
    const readerPhone = document.body.classList.contains('ap-reader-pdp') && matchMedia('(max-width: 899px)').matches;
    const pastPurchase = form.getBoundingClientRect().bottom < viewTop;
    sticky.hidden = modal || (readerPhone ? !pastPurchase : !pastTitle || mainVisible);
    document.body.classList.toggle('has-sticky-purchase', !sticky.hidden);
  }
  const scheduleSticky = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateSticky); } };
  window.addEventListener('scroll', scheduleSticky, {passive: true});
  window.addEventListener('resize', scheduleSticky);
  window.visualViewport?.addEventListener('resize', scheduleSticky);
  window.visualViewport?.addEventListener('scroll', scheduleSticky, {passive: true});
  window.addEventListener('pageshow', scheduleSticky);
  // The preview bar is inserted after load; watch the body's direct children for it.
  new MutationObserver(scheduleSticky).observe(document.body, {childList: true});
  $$('dialog').forEach(d => new MutationObserver(scheduleSticky).observe(d, {attributes: true, attributeFilter: ['open']}));
  if (sticky && 'ResizeObserver' in window) new ResizeObserver(entries => {
    const h = entries[0].borderBoxSize?.[0]?.blockSize || sticky.offsetHeight;
    if (h > 0) document.documentElement.style.setProperty('--ap-sticky-h', Math.ceil(h) + 'px');
  }).observe(sticky);
  updatePurchase();
  // Every purchase listener is installed and the hidden fields match the selected offer: unlock the purchase controls.
  if (purchaseLock) purchaseLock.disabled = false;
  $('[data-purchase-unavailable]')?.setAttribute('hidden', '');
  updateSticky();

  /* Explore benefits: move to the complete benefit list and give it focus. */
  $$('[data-explore-benefits]').forEach(link => link.addEventListener('click', e => {
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({behavior: paused || reduce.matches ? 'auto' : 'smooth', block: 'start'});
    target.focus({preventScroll: true});
  }));

  /* Ingredient tabs */
  const ingredientTabs = $$('[data-ingredient]');
  function selectIngredient(tab) {
    ingredientTabs.forEach(t => {
      const active = t === tab;
      t.setAttribute('aria-selected', String(active));
      t.tabIndex = active ? 0 : -1;
      const panel = $('#ingredient-' + t.dataset.ingredient);
      panel.hidden = !active;
      if (active) animatePdp(panel, [{opacity: 0, transform: 'translateY(7px)'}, {opacity: 1, transform: 'translateY(0)'}], 360);
    });
  }
  ingredientTabs.forEach((tab, i) => {
    tab.addEventListener('click', () => selectIngredient(tab));
    tab.addEventListener('keydown', e => {
      let n;
      if (e.key === 'ArrowRight') n = (i + 1) % ingredientTabs.length;
      if (e.key === 'ArrowLeft') n = (i + ingredientTabs.length - 1) % ingredientTabs.length;
      if (e.key === 'Home') n = 0;
      if (e.key === 'End') n = ingredientTabs.length - 1;
      if (n !== undefined) { e.preventDefault(); selectIngredient(ingredientTabs[n]); ingredientTabs[n].focus(); }
    });
  });

  /* Reviews: the server renders this product's twelve saved Judge.me reviews, all readable without JavaScript.
     Here they show three at a time with topic filters and "Read more reviews", then refresh from this product's own
     public Judge.me list. A live record counts only with this product's URL path (and product id when given), a whole
     1-5 rating, a reviewer name and text; fewer than twelve are topped up from the saved reviews without duplicates
     (same review id or the same text). Every live string is escaped. */
  const reviewsSection = $('[data-ap-reviews]');
  if (reviewsSection) {
    const LIMIT = 12, SHOWN = 3;
    const grid = $('#filtered-reviews');
    const status = $('#review-results');
    const more = $('#more-reviews-button');
    const empty = $('[data-reviews-empty]', reviewsSection);
    const filterButtons = $$('[data-review-filter]', reviewsSection);
    const esc = s => String(s).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
    const textKey = s => 'text:' + String(s).replace(/\s+/g, ' ').trim().toLowerCase();
    const validRating = n => Number.isInteger(n) && n >= 1 && n <= 5;
    const pathOf = u => { try { return new URL(u, location.origin).pathname.replace(/\/+$/, ''); } catch (_) { return null; } };
    const productPath = pathOf(reviewsSection.dataset.productUrl);
    const productId = String(reviewsSection.dataset.productId || '');
    const topics = [
      {id: 'all', name: 'All reviews', test: () => true},
      {id: 'experience', name: 'Product experience', test: r => /feel|feeling|doing better/i.test(r.body)},
      {id: 'delivery', name: 'Delivery', test: r => /delivery|shipping|shipped/i.test(r.body)},
      {id: 'service', name: 'Customer service', test: r => /communication|support|helpful/i.test(r.body)}
    ];
    const saved = $$('[data-review]', grid).map(card => ({
      rating: Number(card.dataset.rating),
      body: card.querySelector('blockquote').textContent.trim().replace(/^“|”$/g, ''),
      name: card.querySelector('.review-person strong').textContent,
      date: card.querySelector('.review-person span').textContent
    })).filter(r => validRating(r.rating) && r.body);
    let reviews = saved.slice(0, LIMIT);
    let topic = 'all';
    let expanded = false;
    const stars = n => '★'.repeat(n) + '☆'.repeat(5 - n);
    const card = r => `<article class="review-card" data-review data-rating="${r.rating}"><span class="review-stars" role="img" aria-label="${r.rating} out of 5 stars">${stars(r.rating)}</span><blockquote>“${esc(r.body)}”</blockquote><div class="review-person"><strong>${esc(r.name)}</strong><span>${esc(r.date)}</span></div></article>`;
    function renderReviews({animate = true, announce = true} = {}) {
      const current = topics.find(t => t.id === topic);
      const matches = reviews.filter(current.test);
      const shown = expanded ? matches : matches.slice(0, SHOWN);
      grid.innerHTML = shown.map(card).join('');
      grid.hidden = !matches.length;
      empty.hidden = !!matches.length;
      filterButtons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.reviewFilter === topic)));
      more.hidden = matches.length <= SHOWN;
      more.setAttribute('aria-expanded', String(expanded));
      more.textContent = expanded ? 'Show fewer reviews' : 'Read more reviews';
      if (announce) status.textContent = matches.length ? `${current.name}: showing ${shown.length} of ${matches.length} reviews.` : 'No reviews for this topic yet.';
      if (animate) animatePdp(grid, [{opacity: .35}, {opacity: 1}], 220);
    }
    filterButtons.forEach(b => b.addEventListener('click', () => { topic = b.dataset.reviewFilter; expanded = false; renderReviews(); }));
    $('[data-review-filter-reset]', reviewsSection)?.addEventListener('click', () => {
      topic = 'all'; expanded = false; renderReviews();
      filterButtons.find(b => b.dataset.reviewFilter === 'all')?.focus();
    });
    // Collapsing keeps the button where it was on screen, so the page does not jump to the footer.
    more.addEventListener('click', () => {
      const before = more.getBoundingClientRect().top;
      expanded = !expanded;
      renderReviews();
      if (!expanded) window.scrollBy({top: more.getBoundingClientRect().top - before, behavior: 'instant'});
    });
    if (saved.length) {
      $('.review-filters', reviewsSection).hidden = false;
      renderReviews({animate: false, announce: false});
    }
    const month = iso => { const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleDateString('en-US', {month: 'long', year: 'numeric', timeZone: 'UTC'}); };
    const url = `https://judge.me/reviews/reviews_for_widget?url=${encodeURIComponent(reviewsSection.dataset.shopDomain)}&shop_domain=${encodeURIComponent(reviewsSection.dataset.shopDomain)}&platform=shopify&page=1&per_page=${LIMIT}&product_id=${encodeURIComponent(productId)}`;
    fetch(url, {headers: {Accept: 'application/json'}}).then(r => r.ok ? r.json() : Promise.reject(r.status)).then(data => {
      if (!data || !Array.isArray(data.reviews) || !productPath) return;
      if (data.product_external_id != null && String(data.product_external_id) !== productId) return;
      const seen = new Set();
      const live = [];
      for (const r of data.reviews) {
        if (live.length === LIMIT) break;
        if (!r || typeof r.product_url !== 'string' || pathOf(r.product_url) !== productPath) continue;
        if (r.product_external_id != null && String(r.product_external_id) !== productId) continue;
        const rating = Number(r.rating);
        const body = (new DOMParser().parseFromString(String(r.body_html || ''), 'text/html').body.textContent || '').trim();
        const name = typeof r.reviewer_name === 'string' ? r.reviewer_name.trim() : '';
        if (!validRating(rating) || !body || !name) continue;
        const id = r.uuid ? 'id:' + r.uuid : '';
        if ((id && seen.has(id)) || seen.has(textKey(body))) continue;
        if (id) seen.add(id);
        seen.add(textKey(body));
        live.push({rating, body, name, date: month(r.created_at)});
      }
      if (!live.length) return;
      reviews = live.concat(saved.filter(s => !seen.has(textKey(s.body)))).slice(0, LIMIT);
      $('.review-filters', reviewsSection).hidden = false;
      renderReviews({animate: false, announce: false});
    }).catch(() => { /* keep the saved reviews */ });
  }

  /* Product films */
  let videos = {};
  try { videos = JSON.parse($('[data-ap-videos]')?.textContent || '{}'); } catch (_) {}
  const videoDialog = $('#pdp-video-dialog');
  const video = videoDialog?.querySelector('video');
  $$('[data-video]').forEach(b => b.addEventListener('click', () => {
    const v = videos[b.dataset.video] || videos.routine || videos.intro;
    if (!v || !video) return;
    $('#pdp-video-title').textContent = v.title;
    video.poster = v.poster;
    video.src = v.src;
    $('.pdp-video-fallback').hidden = true;
    videoDialog.showModal();
    video.focus();
    video.play().catch(() => {});
  }));
  videoDialog?.addEventListener('close', () => video.pause());
  videoDialog?.addEventListener('cancel', () => video.pause());
  video?.addEventListener('error', () => { $('.pdp-video-fallback').hidden = false; });

  /* Dialogs (the cart drawer handles its own close) */
  $$('dialog:not(#bag-dialog) [data-close]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
  $$('dialog:not(#bag-dialog)').forEach(d => d.addEventListener('click', e => {
    if (e.target !== d) return;
    const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
  }));

  /* Mobile menu */
  const menu = $('.menubtn');
  // The button reads Close while the menu is open and Menu after it closes (labels from the header settings).
  const setMenu = open => {
    if (!menu) return;
    menu.setAttribute('aria-expanded', String(open));
    const label = open ? menu.dataset.labelOpen : menu.dataset.labelClosed;
    if (label) menu.textContent = label;
    $('.mainnav')?.classList.toggle('open', open);
  };
  const closeMenu = () => setMenu(false);
  menu?.addEventListener('click', () => setMenu(menu.getAttribute('aria-expanded') !== 'true'));
  $$('.mainnav a').forEach(a => a.addEventListener('click', closeMenu));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

  /* Section navigation: only sections this product renders, with the current one marked. */
  const sectionLinks = $$('.pdp-section-nav a').filter(a => {
    if (document.querySelector(a.hash)) return true;
    a.remove();
    return false;
  });
  const detailsObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      sectionLinks.forEach(a => {
        const active = a.hash === '#' + entry.target.id;
        a.classList.toggle('is-active', active);
        if (active) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
    });
  }, {rootMargin: '-18% 0px -60% 0px', threshold: 0});
  sectionLinks.forEach(a => { const s = document.querySelector(a.hash); if (s) detailsObserver.observe(s); });
})();
